export default function Label({ text, image, name }) {
   const { useState,useEffect } = window.wp.element;
   const [labelUrl, setLabelUrl] = useState('');
   const [labelTitle, setLabelTitle] = useState('');
   const [isStartFetching, setIsStartFetching] = useState(false);


    useEffect(() => {
      const wkmp_stripe = wkmp_stripe_connect_util;

      if (!!labelUrl) {
         return;
      }

      if (isStartFetching) {
         return;
      }

      if (!image) {

         setIsStartFetching(true);

         jQuery.ajax({
            url   : wkmp_stripe.ajax_url,
            method: 'POST',
            data: {
               action     : 'wkmp_stripe_get_payment_method_data',
               security   : wkmp_stripe.nonce,
               payment_method: name
            },
            success: function(res) {

               if(!!res.icon){
                  setLabelUrl(res.icon);
               }
               if(!!res.title){
                  setLabelTitle(res.title);
               }

               setIsStartFetching(false);

            }
         });

      }

   });

   return (
      <span style={{ width: '100%' }}>
         {
            labelTitle
               ? labelTitle
               : text
         }
         {
            labelUrl
            ? <img src={labelUrl} style={{ float: 'right', marginRight: '20px' }} />
            : image ? <img src={image} style={{ float: 'right', marginRight: '20px' }} /> : ''
         }
     </span>
   )
}
